import axios, { AxiosResponse } from 'axios';

export const location = {
  getDeliveryLocationForms: (deviceId, language): Promise<AxiosResponse> =>
    axios.get(
      `/map/DeliveryLocationForms?deviceId=${deviceId}&language=${language}`,
    ),

  postDeliveryLocationForm: (payload): Promise<AxiosResponse> =>
    axios.post('/map/DeliveryLocationForm', payload),

  postFormatGoogleAddress: (language, payload): Promise<AxiosResponse> =>
    axios.post(`/address/formatGoogleAddress?language=${language}`, payload),
};
